/**
 * El idioma con que se usó el portal por última vez **en este navegador**.
 *
 * Lo lee la portada al arrancar y lo lee la API al mandar a la persona a la
 * pantalla de acceso, que sale antes de saber quién es (`LANGUAGE_COOKIE` en
 * `apps/api/src/api/auth/auth.controller.ts`). No lleva nada personal.
 *
 * Sin ella, español. El idioma del navegador no decide: una Mac con el inglés
 * primero ponía el acceso en inglés a quien nunca lo pidió.
 */
const COOKIE = 'idioma';
const UN_ANO = 60 * 60 * 24 * 365;
const IDIOMAS = ['es-MX', 'en-US'];

export function idiomaGuardado(): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const valor = document.cookie
    .split('; ')
    .find((par) => par.startsWith(`${COOKIE}=`))
    ?.slice(COOKIE.length + 1);
  return valor && IDIOMAS.includes(valor) ? valor : undefined;
}

export function recordarIdioma(locale: string): void {
  if (typeof document === 'undefined' || !IDIOMAS.includes(locale)) return;
  const segura = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE}=${locale}; Path=/; Max-Age=${UN_ANO}; SameSite=Lax${segura}`;
}
